export const createExternalKeyForCmsCollection = (collectionId: string) => {
  return `cms-collection-type-${collectionId}`;
};
